"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GeneralConfig = _interopRequireDefault(require("./components/GeneralConfig.vue"));
var _FlowerJoyConfig = _interopRequireDefault(require("./components/FlowerJoyConfig.vue"));
var _JoyShareConfig = _interopRequireDefault(require("./components/JoyShareConfig.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MealConfig',
  components: {
    GeneralConfig: _GeneralConfig.default,
    FlowerJoyConfig: _FlowerJoyConfig.default,
    JoyShareConfig: _JoyShareConfig.default
  },
  data: function data() {
    return {
      activeName: 'general',
      refreshLoading: false
    };
  },
  methods: {
    // 刷新当前标签页数据
    refreshCurrentTab: function refreshCurrentTab() {
      var _this = this;
      this.refreshLoading = true;
      var currentTab = this.activeName;
      try {
        if (currentTab === 'general' && this.$refs.generalConfig) {
          this.$refs.generalConfig.fetchBrandConfigList();
        } else if (currentTab === 'flowerJoy' && this.$refs.flowerJoyConfig) {
          this.$refs.flowerJoyConfig.fetchFlowerConfig();
        } else if (currentTab === 'joyShare' && this.$refs.joyShareConfig) {
          this.$refs.joyShareConfig.fetchJoyShareConfig();
        }
      } catch (error) {
        console.error('刷新数据失败:', error);
      } finally {
        setTimeout(function () {
          _this.refreshLoading = false;
        }, 500);
      }
    },
    // 标签页切换事件
    handleTabClick: function handleTabClick() {
      // 切换标签页时自动刷新数据
      this.refreshCurrentTab();
    }
  }
};